export const VIEW_OWN_SCHEDULED_ONLY: string = "custom_view_own_schedule_only";
export const VIEW_OWN_REPORTS_ONLY: string = "custom_view_own_reports_only";
export const VIEW_REPORTS: string = "custom_view_reports";
